import type { Dispatch, FC, SetStateAction } from 'react'
import { Flex, Spin, Select } from '@/components'
import { envs } from '@/envs'

import { CategoryCard } from '../category-card'
import { DocumentCard } from '../document-card'
import {
  SC_SubcategoriesDrawerWrapper,
  SC_DocumentsListWrapper }
  from './styled'
import type { T_CategoriesResponse, T_DocumentResponse, T_DocsResponse } from '@/types/responses'
import type { T_NavItem } from '../../documents-drawer'

type T_CategoryInnerProps = {
  current: T_NavItem
  categoryId: string
  cats?: T_CategoriesResponse
  docs?: T_DocsResponse
  isLoading: boolean
  onSetStack: Dispatch<SetStateAction<T_NavItem[]>>
  stack: T_NavItem[]
  push: (item: any) => void
}

export const CategoryInner: FC<T_CategoryInnerProps> = ({
  current,
  onSetStack,
  stack,
  categoryId,
  cats,
  docs,
  isLoading,
  push,
}) => {
  const isFirstLevel = current.name === 'category-inner' && stack.length === 2

  const handleCategoryChange = (value: string) => {
    onSetStack((s) => {
      const next = [ ...s ]
      const cat = cats?.find((c) => c.name === value)

      if (cat) {
        next[next.length - 1] = {
          name: 'category-inner',
          title: cat.title?.ru ?? cat.name,
          categoryId: cat.name,
        }
      }
      return next
    })
  }

  const handleReadDocument = (doc: T_DocumentResponse) => {
    if ('link' in doc && doc.link?.ru) {
      window.open(`${envs.API_DOMAIN}${doc.link.ru}`, '_blank', 'noopener,noreferrer')
    } else {
      push({
        name: 'document',
        title: doc.title?.ru ?? doc.name,
        categoryId,
        docName: doc.name,
      })
    }
  }

  return (
    <SC_SubcategoriesDrawerWrapper>
      {isFirstLevel && (
        <Select
          name='category'
          value={categoryId}
          onSelect={handleCategoryChange}
          options={cats?.map((c) => ({
            value: c.name,
            label: c.title?.ru ?? c.name,
          }))}
        />
      )}

      {isLoading ? (
        <Flex justify='center' align='center'>
          <Spin size='large' />
        </Flex>
      ) : docs?.length ? (
        <SC_DocumentsListWrapper>
          {docs.map((s) =>
            s.children ? (
              <CategoryCard
                key={s.name}
                title={s.title?.ru ?? s.name}
                onClick={() =>
                  push({
                    name: 'category-inner',
                    title: s.title?.ru ?? s.name,
                    categoryId: s.name,
                  })
                }
              />
            ) : (
              <DocumentCard
                key={s.name}
                title={s.title?.ru ?? s.name}
                description={s.description?.ru}
                onRead={() => handleReadDocument(s)}
              />
            )
          )}
        </SC_DocumentsListWrapper>
      ) : (
        <Flex justify='center'>
          <h5>В данной категории пока нет документов</h5>
        </Flex>
      )}
    </SC_SubcategoriesDrawerWrapper>
  )
}
